export default __webpack_public_path__ + "static/media/Deployment_Bg-Loop.c3424310.mp4";